import * as actionTypes from "../ActionTypes";

// SAVE
export const saveServiceVideoRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_SERVICE_VIDEO_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const saveServiceVideoSuccess = (data) => ({
  type: actionTypes.SAVE_SERVICE_VIDEO_SUCCESS,
  payload: data,
});

export const saveServiceVideoFailure = (error) => ({
  type: actionTypes.SAVE_SERVICE_VIDEO_FAILURE,
  payload: error,
});

// UPDATE
export const updateServiceVideoRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.UPDATE_SERVICE_VIDEO_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const updateServiceVideoSuccess = (data) => ({
  type: actionTypes.UPDATE_SERVICE_VIDEO_SUCCESS,
  payload: data,
});

export const updateServiceVideoFailure = (error) => ({
  type: actionTypes.UPDATE_SERVICE_VIDEO_FAILURE,
  payload: error,
});

// DELETE
export const deleteServiceVideoRequest = (payload, callback) => ({
  type: actionTypes.DELETE_SERVICE_VIDEO_REQUEST,
  payload,
  callback,
});

export const deleteServiceVideoSuccess = (data) => ({
  type: actionTypes.DELETE_SERVICE_VIDEO_SUCCESS,
  payload: data,
});

export const deleteServiceVideoFailure = (error) => ({
  type: actionTypes.DELETE_SERVICE_VIDEO_FAILURE,
  payload: error,
});

// READ
export const readServiceVideoRequest = (payload, callback) => ({
  type: actionTypes.READ_SERVICE_VIDEO_REQUEST,
  payload,
  callback,
});

export const readServiceVideoSuccess = (data) => ({
  type: actionTypes.READ_SERVICE_VIDEO_SUCCESS,
  payload: data,
});

export const readServiceVideoFailure = (error) => ({
  type: actionTypes.READ_SERVICE_VIDEO_FAILURE,
  payload: error,
});
